import { Formik, Field, Form } from "formik";
import "./DynamicFormik.scss";
import FormikInputsPosition from "../../Molecules/FormikInputsPosition/FormikInputsPosition";

function DynamicFormik({
  buttonContent,
  field_1,
  field_2,
  field_3,
  field_4,
  field_5,
  field_6,
  field_7,
}) {
  return (
    <Formik
      initialValues={{
        [field_1.requestKey]: "",
        [field_2.requestKey]: "",
        [field_3.requestKey]: "",
        [field_4.requestKey]: "",
        [field_5.requestKey]: "",
        [field_6.requestKey]: "",
        [field_7.requestKey]: "",
      }}
      onSubmit={(values, actions) => {
        console.log(values);
        actions.resetForm();
      }}
    >
      <Form className={"all-width-height grid fullColumn dynamicFormik-container"}>
        <FormikInputsPosition title={field_1.title} position="1">
          <Field
            name={field_1.requestKey}
            type="text"
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        {/* usar el segundo campo siempre para email */}
        <FormikInputsPosition title={field_2.title} position="2">
          <Field
            name={field_2.requestKey}
            type="email"
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        <FormikInputsPosition title={field_3.title} position="3">
          <Field
            name={field_3.requestKey}
            type="text"
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        <FormikInputsPosition title={field_4.title} position="4">
          <Field
            name={field_4.requestKey}
            type="text"
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        <FormikInputsPosition title={field_5.title} position="5">
          <Field
            name={field_5.requestKey}
            type="text"
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        {/* el campo 6 sera de tipo variable */}
        <FormikInputsPosition title={field_6.title} position="6">
          <Field
            name={field_6.requestKey}
            type={field_6.type}
            className="dynamicFormik-input-styles"
          />
        </FormikInputsPosition>

        {/* el ultimo campo siempre sera un textarea */}
        <FormikInputsPosition title={field_7.title} position="7">
          <Field
            name={field_7.requestKey}
            as="textarea"
            rows="1"
            className="dynamicFormik-input-styles text-area"
          />
        </FormikInputsPosition>

        <button
          type="submit"
          className="button light-blue dynamicFormik-button"
        >
          {buttonContent}
        </button>
      </Form>
    </Formik>
  );
}

export default DynamicFormik;
